module.exports = __webpack_public_path__ + "img/_qft_.e80fe7b5.svg";